import {Response, ResponseInterceptor, ServiceBuilder} from 'ts-retrofit';
import {environment} from '../../../environments/environment';
import {RequestInterceptorFunction} from 'ts-retrofit/lib/types/baseService';
import {RestApiError} from './rest-api-error';
import {getToken, reset, setToken} from '../session-storage.service';
import {HttpStatusCode} from '@angular/common/http';

export const ACCEPT_JSON = {Accept: 'application/json'};
export const AUTHORIZATION = 'Authorization';
export const TIMEZONE = 'TimezoneIana';

const requestInterceptor: RequestInterceptorFunction = (request) => {
    const token = getToken();
    const timezoneIanaFormat = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (token) {
        request.headers = {
            ...request.headers,
            AUTHORIZATION: `Bearer ${token}`
        };
    }
    request.headers[TIMEZONE] = timezoneIanaFormat;

    return request;
};

function getRequestUrl(error: any): string {
    return error?.response?.config?.url
        ?? error?.config?.url
        ?? error?.request?.responseURL
        ?? '';
}

function isChangePasswordRequest(error: any): boolean {
    const requestUrl = getRequestUrl(error);

    return typeof requestUrl === 'string' && requestUrl.includes('/users/change-password');
}

function isLoginRequest(error: any): boolean {
    const requestUrl = getRequestUrl(error);

    return typeof requestUrl === 'string' && requestUrl.includes('/auth/login');
}

function shouldReloadOnUnauthorized(error: any): boolean {
    return !isLoginRequest(error) && !isChangePasswordRequest(error);
}

class AppResponseInterceptor extends ResponseInterceptor {
    // @ts-ignore
    onFulfilled(value) {

        const authHeader = value.headers[AUTHORIZATION] ?? value.headers[AUTHORIZATION.toLowerCase()];
        if (authHeader) {
            setToken(authHeader);
        }

        return value;
    }

  override onRejected(error: any) {
        if (error.response == null) {
            // TODO: tradurre
            throw new RestApiError('Problema di connessione internet. Se sei da una rete mobile verifica di avere campo.', 0);
        }

        if (error.response?.status === HttpStatusCode.Unauthorized && shouldReloadOnUnauthorized(error)) {
            reset();
            location.reload();
        }

        throw new RestApiError(
            error.response.data?.errorMessage ??
            error.response.data?.title ??
            error.response.data?.message ??
            '', error.response.status, error.response.data);
    }
}

const responseInterceptor = new AppResponseInterceptor();

export const serviceFactory = <T>(service: new (builder: ServiceBuilder, ...args: any[]) => T) => {
    return new ServiceBuilder()
        .setEndpoint(environment.baseApi)
        .setStandalone(true)
        .setRequestInterceptors(requestInterceptor)
        .setResponseInterceptors(responseInterceptor)
        .build(service);
};


export function goodResponseState<T>(data: T): Response<T> {
    return <Response<T>>{
        data: data,
        config: {},
        headers: {},
        status: 200,
        statusText: 'Cached response',
        request: 'Cached response'
    };
}
